import { render, staticRenderFns } from "./achCardList.vue?vue&type=template&id=61870cce"
import script from "./achCardList.vue?vue&type=script&lang=js"
export * from "./achCardList.vue?vue&type=script&lang=js"
import style0 from "./achCardList.vue?vue&type=style&index=0&id=61870cce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports